import { render, staticRenderFns } from "./ClientDefaultOpportunities.vue?vue&type=template&id=492c82ac&scoped=true"
import script from "./ClientDefaultOpportunities.vue?vue&type=script&lang=js"
export * from "./ClientDefaultOpportunities.vue?vue&type=script&lang=js"
import style0 from "./ClientDefaultOpportunities.vue?vue&type=style&index=0&id=492c82ac&prod&scoped=true&lang=css"
import style1 from "./ClientDefaultOpportunities.vue?vue&type=style&index=1&id=492c82ac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c82ac",
  null
  
)

export default component.exports